import { Box, Button, Text } from '@factorialco/deprecated-design-system'
import { AccessCalendarSyncItemFragment } from 'generated/resources/graphql'

import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'

import { useCreateCalendarSync } from './useCreateCalendarSync'

interface Props {
  accessId: string
  calendarSync?: AccessCalendarSyncItemFragment | null
}

export const ConnectMyCalendar = ({ accessId, calendarSync }: Props) => {
  const { createCalendarSync, loading: creating } = useCreateCalendarSync()

  const syncCalendar = async () => {
    if (calendarSync?.oauthUrl) {
      window.location.href = calendarSync.oauthUrl
    }
    const result = await createCalendarSync({ accessId })
    const handled = handleResult(result, () => undefined)
    if (handled.success && handled.data.calendarSync && handled.data.calendarSync.oauthUrl) {
      window.location.href = handled.data.calendarSync.oauthUrl
    }
  }

  return (
    <Box height="full" gap="s24" justifyContent="center">
      <Text.Normal size="300" weight="semibold">
        {i18n.t('cronofy.user_calendar_sync.non_connected_calendar.title')}
      </Text.Normal>
      <Text.Normal size="300">
        {i18n.t('cronofy.user_calendar_sync.non_connected_calendar.description')}
      </Text.Normal>
      <Button onClick={syncCalendar} loading={creating}>
        {i18n.t('cronofy.user_calendar_sync.non_connected_calendar.button')}
      </Button>
    </Box>
  )
}
